module.exports = __webpack_public_path__ + "static/media/interview11.8c8ffcc2.jpg";